import { Component, ViewEncapsulation, EventEmitter, Output, ElementRef, Input, Injector, AfterViewInit ,AfterViewChecked} from '@angular/core';
import { MapService } from '../../../shared/services/maps/map.service';
import { AppConfigService } from '../../../shared/services/app-config.service';
import { ConfigurationKeyEnum } from '../../../shared/dataModels/data-models';
import { Configuration } from '../../configurations/shared.config';
import { DiagnosedItem } from '../../dataModels/diagnosed-item';
import { MapTocComponent } from '../mapTools/mapToc/map-toc.component';
@Component({
    moduleId: module.id,
    selector: 'common-map',
    templateUrl: 'common-map.component.html',
    styleUrls: ['../../../assets/css/map.css'],
    encapsulation: ViewEncapsulation.None,
})

export class CommonMapComponent extends DiagnosedItem implements AfterViewInit,AfterViewChecked {
    @Input() zoom: number;
    @Input() mapType: string;
    centerX: number;
    centerY: number;
    mapUrl: string;
    minZoom: number;
    maxZoom: number;
    mapView: string = "globe";
    @Output() MapComponentLoaded: EventEmitter<any> = new EventEmitter();
    @Input() MapID: any;
    @Input() showMapControls: boolean = true;
    get isGoogleMode() { return this._mapService.isGoogleMode; };
    isMapControlLoaded: boolean = false;
    @Input() hideOverlay: boolean = true;
    constructor(private _mapService: MapService, private elRef: ElementRef, private _appConfigService: AppConfigService, protected injector: Injector) {
        super(injector);



    }
    async  ngOnInit() {
        if (this.MapID) {
            this._mapService.MapID = this.MapID;
        }
        else {
            this.MapID = 'map'
            this._mapService.MapID = 'map';
        }
        this._mapService.showMapControls = this.showMapControls;
        this._mapService.enableHideOverlay = this.hideOverlay;
        var result = await this._appConfigService.getSubscriberConfiguration();
        if (result) {
            // get Longitude Value
            var long = result.Configurations.find((x) => x.Key == ConfigurationKeyEnum.DefaultLongitude.toString());
            this.centerX = long ? parseFloat(long.Value) : null;
            // get Latitude Value
            var lat = result.Configurations.find((x) => x.Key == ConfigurationKeyEnum.DefaultLatitude.toString());
            this.centerY = lat ? parseFloat(lat.Value) : null;
            // get Zoom Value
            var zoomResult = result.Configurations.find((x) => x.Key == ConfigurationKeyEnum.DefaultZoom.toString());
            this.zoom = zoomResult ? parseInt(zoomResult.Value) : null;
            // get Map Url Value
            var MapUrlResult = result.Configurations.find((x) => x.Key == ConfigurationKeyEnum.MapUrl.toString());
            //this.mapUrl = MapUrlResult ? MapUrlResult.Value : null;
            this.mapUrl = MapUrlResult ? MapUrlResult.Value : null;
            // get Map type Value
            var mapTypeResult = result.Configurations.find((x) => x.Key == ConfigurationKeyEnum.MapProvider.toString())
            this.mapType = mapTypeResult ? mapTypeResult.Value : null;
            // get min zoom Value
            var minZoomResult = result.Configurations.find((x) => x.Key == ConfigurationKeyEnum.MinZoomLevel.toString());
            this.minZoom = minZoomResult ? parseInt(minZoomResult.Value) : null;
            // get max zoom Value
            var maxZoomResult = result.Configurations.find((x) => x.Key == ConfigurationKeyEnum.MaxZoomLevel.toString());
            this.maxZoom = maxZoomResult ? parseInt(maxZoomResult.Value) : null;

            this._mapService.setMapSettings(this.centerX, this.centerY, this.zoom, this.elRef.nativeElement.firstChild.id, this.mapType, false, this.mapUrl, this.minZoom, this.maxZoom);

            this.MapComponentLoaded.emit(true);
        //     if (this.showMapControls)
        // this._mapService.addGeoCoderControl();
        }
    }

    zoomToPoint(x, y, zoom) {
        this._mapService.centerMap(parseFloat(x), parseFloat(y), parseInt(zoom));
    }

    getZoomLevel() {
        return this._mapService.getZoomLevel();
    }

    getCenter() {
        return this._mapService.getCenter();
    }
    public SwitchMapView() {
        this._mapService.switchBaseMapView();
        if (this.mapView == "map") {
            this.mapView = "globe";
        }
        else {
            this.mapView = "map";
        }

    }
    ngAfterViewInit() {
        
    }
    ngAfterViewChecked() {
        var input = document.getElementById('searchTextField');
        if (this.showMapControls && input && !this.isMapControlLoaded)
        {
            this._mapService.addGoogleGeoCoderControl();
            this.isMapControlLoaded= true;
        }
    }
}




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/commonMap/common-map.component.ts